export enum SUPPLIER_PERMISSIONS {
  SUPPLIER_VIEW = 'PROVIDER_SUPPLIERVIEW',
  SUPPLIER_WRITE = 'PROVIDER_SUPPLIERWRITE',
}
